import { forwardRef } from "react";
import { SVGFillCircle, SVGFillPath, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Avator = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 34.56 42.03" ref={ref} {...props}>
      <SVGFillCircle cx="17.28" cy="8.64" r="8.64" />
      <SVGFillPath
        d="M24,45.61A20.74,20.74,0,0,1,6.72,36.33C6.81,30.6,18.24,27.46,24,27.46s17.19,3.14,17.28,8.87A20.74,20.74,0,0,1,24,45.61Z"
        transform="translate(-6.72 -3.58)"
      />
    </SVGIconRoot>
  );
});
